import { http } from '@/lib/http';
import { saveBlob } from '@/lib/reconciliation/api';
import type { OperatorActivityReport } from './types';

// operator-bff:GET /v1/disruptions/{urn}/operator-activity@v1 (#813) + the `.csv` twin.

const base = (urn: string) => `v1/disruptions/${encodeURIComponent(urn)}/operator-activity`;

export async function fetchOperatorActivity(urn: string): Promise<OperatorActivityReport> {
  return http.get(base(urn)).json<OperatorActivityReport>();
}

export async function fetchOperatorActivityCsv(urn: string): Promise<{ blob: Blob; filename: string }> {
  const res = await http.get(`${base(urn)}.csv`);
  const disposition = res.headers.get('content-disposition') ?? '';
  const match = /filename="([^"]+)"/.exec(disposition);
  return { blob: await res.blob(), filename: match?.[1] ?? 'actividad-operadores.csv' };
}

export { saveBlob };
